module.exports = __webpack_public_path__ + "static/media/portAnchorBlue.56d08311.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/portAnchorBlue.png
// module id = 217
// module chunks = 0